"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteType = deleteType;
exports.getById = getById;
exports.getMakeMethodEstimateInfo = getMakeMethodEstimateInfo;
exports.getTypeById = getTypeById;
exports.queryList = queryList;
exports.queryTypeList = queryTypeList;
exports.queryTypePageList = queryTypePageList;
exports.saveType = saveType;
exports.update = update;
exports.updateType = updateType;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 获取估清信息
function getMakeMethodEstimateInfo(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethod/getMakeMethodEstimateInfo',
    method: 'post',
    data: data
  });
}

// 制作方法列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethod/page',
    method: 'get',
    params: query
  });
}

// 制作方法类型列表
function queryTypeList(query) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethodType/page',
    method: 'get',
    params: query
  });
}

// 制作方法更新
function update(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethod/updateXyGoodsMakeMethod',
    method: 'post',
    data: data
  });
}

// 通过id等级信息
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethod/' + id,
    method: 'get'
  });
}

// ============ 做法分类相关接口 ============

// 做法分类列表
function queryTypePageList(query) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethodType/page',
    method: 'get',
    params: query
  });
}

// 做法分类详情
function getTypeById(id) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethodType/' + id,
    method: 'get'
  });
}

// 保存做法分类
function saveType(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethodType',
    method: 'post',
    data: data
  });
}

// 更新做法分类
function updateType(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethodType',
    method: 'put',
    data: data
  });
}

// 删除做法分类
function deleteType(id) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsMakeMethodType',
    method: 'delete',
    params: {
      id: id
    }
  });
}